import {useState} from "react";
import {useWorkerContext} from "@/components/providers/WorkerProvider";

const useWorkerVariables = (initialDynamicWorkerValues = []) => {
    const {workerObjects} = useWorkerContext()
    const workerVariables = workerObjects.map(w => ({
        id: w.id,
        display: w.tag,
        provider: w.name,
    }))

    const [dynamicWorkerValues, setDynamicWorkerValues] = useState(
        Array.isArray(initialDynamicWorkerValues) ? initialDynamicWorkerValues : []
    )
    const [workerModalOpen, setWorkerModalOpen] = useState(false)
    const [selectedWorker, setSelectedWorker] = useState(null)

    const handleWorkerMentionClick = (varId) => {
        const w = workerObjects.find(w => w.tag === varId || w.tag === `$${varId}`)
        if (w) {
            setSelectedWorker(w)
            setWorkerModalOpen(true)
        }
    }

    const handleWorkerMentionDelete = (varId) => {
        const name = varId.startsWith('$') ? varId : `$${varId}`
        setDynamicWorkerValues(prev => prev.filter(v => v.name !== name))
    }

    const handleWorkerVariableSelect = (varId) => {
        const w = workerObjects.find(w => w.tag === varId || w.tag === `$${varId}`)
        if (!w) return
        const name = `$${w.tag.replace(/^\$/, '')}`
        setDynamicWorkerValues(prev => {
            if (prev?.some(v => v.name === name)) return prev;
            return [...prev, {name, workerId: w.id, mappings: {}}]
        })
    }

    const handleWorkerMappingSave = (workerId, newMappings) => {
        const w = workerObjects.find(w => w.id === workerId)
        if (!w) return
        const name = `$${w.tag.replace(/^\$/, '')}`
        setDynamicWorkerValues(prev => {
            const exists = prev.some(v => v.name === name)
            if (exists) {
                return prev.map(v => v.name === name ? {...v, mappings: newMappings} : v)
            }
            return [...prev, {name, workerId: w.id, mappings: newMappings}]
        })
    }

    const closeWorkerModal = () => setWorkerModalOpen(false)

    const getInitialWorkerMappings = () => {
        if (!selectedWorker) return {}
        const name = `$${selectedWorker.tag.replace(/^\$/, '')}`
        const entry = dynamicWorkerValues.find(v => v.name === name)
        return entry?.mappings ?? {}
    }

    return {
        workerVariables,
        dynamicWorkerValues,
        workerModalOpen,
        selectedWorker,
        handleWorkerMentionClick,
        handleWorkerMentionDelete,
        handleWorkerVariableSelect,
        handleWorkerMappingSave,
        closeWorkerModal,
        getInitialWorkerMappings,
    }
}

export default useWorkerVariables;
